import { useNavigate } from "react-router-dom";

import PurpleStarImage from "../../assets/images/purpleStar.svg";
import LeftArrow from "../../assets/images/arrow-left.svg";
import DDxFeatureImage from "../../assets/images/ddx_feature.webp";
import DDxVideoImage from "../../assets/images/ddx_video_thumbnail.webp";

const DDxAboutPage = () => {
  const navigate = useNavigate();

  return (
    <div className="h-[100dvh] overflow-scroll no-scrollbar">
      <div className="h-[54px] bg-[#F6F3F8] sticky top-0 z-20 flex items-center">
        <img
          src={LeftArrow}
          alt="icon"
          className="ml-4"
          onClick={() => navigate(-1)}
        />
        <p className="text-lg font-semibold text-[#1F2933] ml-1.5">About DDx</p>
      </div>
      <div className="font-poppins bg-[#EFE9F3]">
        <div className="relative rounded-t-3xl">
          <div className="p-6 relative overflow-hidden">
            <div className="absolute -top-6 -right-9">
              <img src={PurpleStarImage} className="h-auto w-28" alt="start" />
            </div>
            <div className="text-left flex flex-col gap-2 font-poppins mt-2">
              <h1 className=" w-[266px] font-bold text-3xl bg-gradient-to-r from-[#4E49E2] via-[#7C2DEF] to-[#B609FF] bg-clip-text text-transparent">
                Revolutionize Diagnosis with AI
              </h1>
              <div className="text-[#454551] w-[98%]">
                Unlock AI-powered precision to identify differential diagnoses.
                Enter patient data, let the AI analyze, and gain clear insights
                to enhance your clinical decisions.
              </div>
            </div>
          </div>

          <div className="relative pb-12 pl-6 pt-9">
            <img
              src={DDxFeatureImage}
              className="w-full h-auto z-10 relative"
              alt="icon"
            />
            <div className="absolute bottom-2 -left-5 z-0">
              <img src={PurpleStarImage} className="h-auto w-28" alt="icon" />
            </div>
          </div>

          <div className="px-6 ">
            <p className="font-semibold text-lg text-left text-[#1F2933]">
              How it works?
            </p>
            <div className="flex flex-col pt-4">
              <>
                <div className="flex items-start justify-center gap-6 ">
                  <div
                    className="w-[52px] h-[48px] rounded-2xl bg-[#BA7DE9]  text-white font-manrope font-bold text-2xl flex items-center justify-center"
                    style={{
                      boxShadow: `0.2px 3.7px 0px 0px #30295C`,
                    }}
                  >
                    1
                  </div>
                  <p className=" w-[80%] text-left text-[#213053]">
                    Provide patient details such as{" "}
                    <span className="font-semibold"> age</span> and
                    <span className="font-semibold"> gender</span>.
                  </p>
                </div>
                <div className="h-7 border-l-[1px] border-dashed  border-[#8584FF] relative left-[7%] w-4 -top-[5%] my-2"></div>
              </>
              <>
                <div className="flex items-start justify-center gap-6">
                  <div
                    className="w-[52px] h-[48px] rounded-2xl bg-[#BA7DE9]  text-white font-manrope font-bold text-2xl flex items-center justify-center"
                    style={{
                      boxShadow: `0.2px 3.7px 0px 0px #30295C`,
                    }}
                  >
                    2
                  </div>
                  <p className="w-[80%] text-left text-[#213053]">
                    Enter <span className="font-semibold"> symptoms</span>{" "}
                    (mandatory) and any additional relevant patients details
                  </p>
                </div>
                <div className="h-7 border-l-[1px] border-dashed  border-[#8584FF] relative left-[7%] w-4 -translate-y-[20%] "></div>
              </>
              <>
                <div className="flex items-start justify-center gap-6  ">
                  <div
                    className="w-[52px] h-[48px] rounded-2xl bg-[#BA7DE9]  text-white font-manrope font-bold text-2xl flex items-center justify-center"
                    style={{
                      boxShadow: `0.2px 3.7px 0px 0px #30295C`,
                    }}
                  >
                    3
                  </div>
                  <p className=" text-left w-[80%] text-[#213053]">
                    Let the AI generate a comprehensive list of differential
                    diagnoses
                  </p>
                </div>
              </>
            </div>
          </div>

          <div className="p-6 pt-10">
            <div className="relative w-full cursor-pointer">
              <video 
                className="w-full h-auto rounded-lg"
                controls
                poster={DDxVideoImage}
                preload="metadata"
              >
                <source src="https://tatvapracticedoctor.blob.core.windows.net/ddx/DDx%20on%20Medeco%202.mp4?sv=2023-01-03&spr=https&st=2025-08-04T07%3A18%3A40Z&se=2029-08-05T07%3A18%3A00Z&sr=b&sp=r&sig=mcG4vn06yLa69VDF8CKlFCwpL%2B3SJnSjTgbWlrNATE0%3D" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DDxAboutPage;
